<template>
  <div id="personal-employee" class="layout personal-employee">
    <employee-form ref="editEmployee" />
    <candidate-modal ref="candidateModal" @on-close="onCandidateSidesheetClose" />

    <div class="personal-employee__header">
      <div class="personal-employee__header__employee">
        <div v-viewer class="personal-employee__header__employee__avatar">
          <div class="svg-wrapper">
            <svg-icon
              name="eye"
              :size="32"
              color="white"
            ></svg-icon>
          </div>
          <img :src="userInfo.photo === null ? noAvatarImg : userInfo.photo" @error="replaceImageOnErrorLoad" />
        </div>
        <div class="personal-employee__header__employee__info">
          <div class="personal-employee__header__employee__info__fullname">
            <div class="personal-employee__header__employee__info__fullname__text">
              {{ userInfo.name }}
            </div>
            <c-worksheet-status-icon
              class="personal-employee__header__employee__info__fullname__worksheet__status only-desktop"
              :worksheet="{
                additional_fields: userInfo.quest_info.additional_fields,
                required_fields: userInfo.quest_info.required_fields,
                total: userInfo.quest_info.total,
              }"
            />
          </div>
          <div class="personal-employee__header__employee__info__block">
            <div class="personal-employee__header__employee__info__filial">
              {{ userInfo.filial }}
            </div>
            <div class="personal-employee__header__employee__info__position">
              <ul class="personal-employee__header__employee__info__position__names">
                <li
                  v-for="(post, index) in userInfo.posts"
                  :key="index"
                  class="personal-employee__header__employee__info__position__names__item"
                >
                  {{ post }}
                  <c-doc-problems-icon
                    v-if="userInfo !== undefined && index === 0 && userInfo.docsStatus"
                    icon-key="doc-problems-desktop"
                    class="personal-employee__header__employee__info__position__names__item__icon only-desktop"
                    :data="{ docsTrouble: userInfo.docsStatus }"
                  />
                  <c-rank-info-icon
                    v-if="userInfo !== undefined && index === 0 && userInfo.rankRecommendations"
                    icon-key="rank-desktop-2"
                    class="personal-employee__header__employee__info__position__names__item__icon only-desktop"
                    :data="userInfo.rankRecommendations"
                  />
                </li>
              </ul>
            </div>
          </div>
          <div class="personal-employee__header__employee__info__experience">
            Стаж:
            <span v-if="userInfo.experience.years">{{ userInfo.experience.years }} г</span
            ><span> {{ userInfo.experience.month }} мес</span>
          </div>
        </div>
      </div>
      <div class="personal-employee__header__buttons">
        <chat-button
          v-if="canViewComment"
          class="personal-employee__header__buttons__top"
          entity="personal_file"
          :entity-id="userInfo.workerId"
          :can-edit="canEditComment"
        />

        <c-button
          v-if="userHavePermissionChangeWorkerStatuses()"
          class="personal-employee__header__buttons__top"
          size="small"
          icon="edit-worker"
          :tooltip="{
            text: 'Настройки сотрудника',
          }"
          @click="toEditWorker"
        />
        <c-button
          v-if="userInfo.candidateId"
          class="personal-employee__header__buttons__top"
          size="small"
          :responsive="true"
          label="Кандидат"
          @click="openCandidateHistory"
        />
        <c-button
          class="personal-employee__header__buttons__to__employees__list"
          size="small"
          :responsive="true"
          icon="back"
          type="with-icon"
          label="К списку сотрудников"
          @click="$router.push({ name: 'employees-list' })"
        />
      </div>
    </div>

    <div class="personal-employee__tabs">
      <c-tabs :items="tabs.items" with-routing />
    </div>

    <div class="personal-employee__content">
      <router-view
        ref="route"
        :user-info="userInfo"
        :filial-id="userInfo.filialId"
        :filial-name="userInfo.filial"
        :worker-full-name="userInfo.name"
        :filials-permission="filialsPermission"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Vue from "vue";

import Button from "@/components/controls2/Button";
import Tabs from "@/components/tabs";
import WorkSheetStatusIcon from "@/pages/personal-employee/additions/worksheet-status-icon";
import DocProblemsIcon from "@/pages/personal-employee/additions/doc-problems-icon";
import RankInfoIcon from "@/pages/personal-employee/additions/rank-info-icon";
import ChatButton from "@/components/chat/ChatButton";
import EmployeeForm from "@/pages/employees/employee-form";
import noAvatarImg from "@/assets/images/userpic.svg";
import SvgIcon from "@/components/svg-icon";
import CandidateModal from "@/components/modals/candidate-modal";

import { userPermissionsList } from "@/constants/userPermissions";

import { subscribe } from "@/utils/events/emitter";
import { CHANGE_USER_FULL_NAME, CHANGE_USER_PHOTO } from "@/utils/events/events";

Vue.use(Viewer, {
  defaultOptions: {
    container: "#personal-employee",
    title: false,
    navbar: false,
    movable: false,
    zoomable: true,
    rotatable: false,
    scalable: false,
    next: false,
    prev: false,
    play: false,
  },
});

export default {
  name: "personal-employee",

  components: {
    EmployeeForm,
    CandidateModal,
    "c-button": Button,
    "c-tabs": Tabs,
    "c-worksheet-status-icon": WorkSheetStatusIcon,
    "c-doc-problems-icon": DocProblemsIcon,
    "c-rank-info-icon": RankInfoIcon,
    ChatButton,
    SvgIcon
  },

  data() {
    return {
      isWorkerChatOpen: false,

      tabs: {
        filialsPermission: {},
        items: [
          {
            label: "Сводка",
            value: "personal-employee-summary",
            permissions: ["viewOwnSummary", "viewWorkerSummary"],
          },
          {
            label: "Основные показатели",
            value: "personal-employee-main-factors",
            permission: "viewMainFactors",
          },
          {
            label: "Финансы",
            value: "personal-employee-finance",
            permissions: [
              "updatePersonalAmount",
              // "viewOwnPersonalAmount",
              "viewPersonalAmount",
              "updateWorkerDeposit",
              // "viewOwnDeposit",
              "viewWorkerDeposit",
              "updateAccountableHistory",
              "viewAccountableHistory",
            ],
          },
          {
            label: "Дисциплина",
            value: "personal-employee-discipline",
            permissions: ["viewFineBonus"],
          },
          {
            label: "Анкета",
            value: "personal-employee-profile",
            permissions: [userPermissionsList.worker.profile.edit, userPermissionsList.worker.profile.view],
          },
          {
            label: "Документы",
            value: "personal-employee-documents",
            permissions: ["updateWorkerDocuments", "viewWorkerDocuments"],
          },
          {
            label: "Договоры",
            value: "personal-employee-agreements",
            permission: "viewWorkerAgreements",
          },
          {
            label: "ТМЦ",
            value: "personal-employee-inventory-items",
            permissions: ["updateWorkerUniform", "viewWorkerUniform"],
          },
          {
            label: "Движение в компании",
            value: "personal-employee-move-in-company",
            permission: "viewWorkerHistory",
          },
          {
            label: "Приведенные сотрудники",
            value: "personal-employee-referrals",
            permissions: [
              "updateAllInvitedWorkers",
              "viewAllInvitedWorkers",
              "viewInvitedWorkers",
              "workerBonusControl",
            ],
          },
        ],
      },
      userInfo: {
        workerId: null,
        candidateId: null,
        docsStatus: null,
        experience: {
          month: null,
          years: null,
        },
        filial: null,
        filialId: null,
        name: null,
        photo: null,
        quest_info: {
          additional_fields: {
            count: null,
            percentage: null,
          },
          required_fields: {
            count: null,
            percentage: null,
          },
          total: {
            count: null,
            percentage: null,
          },
        },
        posts: [],
        postCodes: [],
      },
      noAvatarImg,
    };
  },

  computed: {
    ...mapGetters(["getUserPermissions"]),

    canEditComment() {
      const userPermissions = this.getUserPermissions;
      return userPermissions.includes(userPermissionsList.worker.comment.edit);
    },

    canViewComment() {
      const userPermissions = this.getUserPermissions;
      return userPermissions.includes(userPermissionsList.worker.comment.view) || this.canEditComment;
    },
  },

  mounted() {
    this.tabs.items = this.tabs.items.filter((tab) => {
      if (tab.permission) {
        const c = this.getUserPermissions.findIndex((permission) => permission === tab.permission);
        if (c === -1) {
          return false;
        }
      } else if (tab.permissions) {
        const isTabAvailable = tab.permissions.some((permission) => this.getUserPermissions.includes(permission));
        if (!isTabAvailable) {
          return false;
        }
      } else {
        return true;
      }
      return true;
    });
  },

  async created() {
    this.userInfo.workerId = this.$route.params.id;

    const unsubscribeUserName = subscribe(CHANGE_USER_FULL_NAME, (data) => {
      const { id, name } = data;
      if (id === this.userInfo.workerId) {
        this.userInfo.name = name;
      }
    });

    const unsubscribeUserPhoto = subscribe(CHANGE_USER_PHOTO, (data) => {
      const { id, photo } = data;
      if (id === this.userInfo.workerId) {
        this.userInfo.photo = photo;
      }
    });

    this.unsubscribe = () => {
      unsubscribeUserName();
      unsubscribeUserPhoto();
    };

    await this.$store.dispatch("personalEmployee/getUserInfo", this.userInfo.workerId).then((res) => {
      const data = res.response;

      if (data) {
        this.userInfo.docsStatus = data.docs_status || null;
        this.userInfo.rankRecommendations = data.rank_recommendations || null;
        this.userInfo.experience = data.experience || null;
        this.userInfo.quest_info = data.quest_info || null;
        this.userInfo.filial = data.filial || null;
        this.userInfo.filialId = data.filial_id || null;
        this.userInfo.candidateId = data.candidate_id || null;
        this.userInfo.name = data.name || null;
        this.userInfo.photo = data.photo || null;
        this.userInfo.canEdit = data.canEdit;
        this.userInfo.postCodes = data.postCodes.map((post) => post.post_code) || null;

        Object.values(data.posts).forEach((post) => {
          this.userInfo.posts.push(post);
        });
      }
    });

    await this.$store.dispatch("personalEmployee/getPermissionsTabs").then((res) => {
      this.filialsPermission = res;
      console.log(this.filialsPermission);
      this.tabs.items = this.tabs.items.filter((tab) => {
        const permissions = tab.permissions ? tab.permissions : [tab.permission];
        for (let i=0; i<permissions.length; i++) {
          const permission = permissions[i];
          const c = this.getUserPermissions.findIndex((p) => p === permission);
          if (c>=0) {
            if (permission in res) {
              if (res[permission].length==0 || res[permission].findIndex((f) => f==this.userInfo.filialId)>=0) {
                return true;
              }
            } else return true;
          }
        }
        return false;
      });
    });
  },

  beforeDestroy() {
    this.unsubscribe();
  },

  methods: {
    openCandidateHistory() {
      // this.$refs.candidateModal.openSidesheet({ candidateId: this.userInfo.candidateId, tab: "history" });
      //
      // const classesToDisableRelativePosition = [".sticky-column", ".c-table__header", ".c-table__shadow"];
      // classesToDisableRelativePosition.forEach((className) => {
      //   document.querySelectorAll(className).forEach((element) => {
      //     element.style.position = "static";
      //   });
      // });
      this.$router.push({
        name: "candidates-profile",
        params: {
          id: this.userInfo.candidateId,
        },
      });
    },
    replaceImageOnErrorLoad(e) {
      e.target.src = this.noAvatarImg;
    },
    toEditWorker() {
      const userPermissions = this.getUserPermissions;
      this.$refs.editEmployee.open(this.$route.params.id, !userPermissions.includes("hideWorkerStatus"));
      // window.open(`${window.location.origin}/index.php?r=worker%2Fupdate&id=${this.userInfo.workerId}`, "_blank");
    },

    userHavePermissionChangeWorkerStatuses() {
      const userPermissions = this.getUserPermissions;
      return userPermissions.includes("workerControl") || userPermissions.includes("workerControlFilial");
    },
  },
};
</script>

<style lang="scss" scoped>
.personal-employee {
  padding: 25px 30px 30px 30px;
  position: relative;

  @media screen and (max-width: 700px) {
    padding: 20px;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;

    @media screen and (max-width: 768px) {
      margin-bottom: 16px;
    }

    @media screen and (max-width: 700px) {
      margin-bottom: 9px;
      flex-wrap: wrap;
    }

    &__employee {
      display: flex;
      // align-items: center;

      &__avatar {
        cursor: pointer;
        width: 100px;
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        margin-right: 20px;
        position: relative;

        @media (max-width: 1023px) {
          width: 52px;
          height: 52px;
        }
        .svg-wrapper {
          position: absolute;
          top: 0;
          height: 100%;
          width: 100%;
          pointer-events: none;
          left: 0;
          background: rgba(0,0,0,.7);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transition: .2s ease-in-out;
        }

        &:hover {
          .svg-wrapper {
            opacity: 1;
          }
        }

        & img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          object-fit: cover;
        }

        @media screen and (max-width: 768px) {
          align-self: flex-start;
          width: 52px;
          height: 52px;
          flex-shrink: 0;
        }

        @media screen and (max-width: 700px) {
          margin-right: 13px;
        }
      }

      &__info__block {
        display: flex;
        flex-direction: column;

        @media screen and (max-width: 700px) {
          margin-bottom: 13px;
          margin-top: 0px;
        }

        @media (max-width: 450px) {
          margin-left: -65px;
          margin-top: 28px;
          padding-top: 9px;
        }
      }

      &__info {
        display: flex;
        flex-direction: column;

        &__fullname {
          display: flex;
          align-items: center;
          font-weight: 500;
          font-size: 22px;
          line-height: 108%;
          margin-bottom: 9px;
          margin-right: 20px;

          @media screen and (max-width: 768px) {
            margin-bottom: 10px;
            font-size: 22px;
            margin-right: 11px;

            &__text {
              max-width: 300px;
              overflow-wrap: break-word;
            }
          }

          @media screen and (max-width: 500px) {
            margin-bottom: 5px;
            &__text {
              overflow-wrap: normal;
              // word-break: break-all;
            }
          }

          @media screen and (max-width: 460px) {
            font-size: 18px;
          }

          &__worksheet__status {
            cursor: pointer;
            margin-left: 14px;

            @media screen and (max-width: 500px) {
              margin-right: 14px;
            }
          }
        }

        &__filial {
          font-weight: 500;
          font-size: 13px;
          line-height: 120%;

          @media screen and (max-width: 768px) {
            margin-right: 15px;
          }
        }

        &__position {
          display: flex;

          &__names {
            list-style-type: none;
            margin: 0;
            padding: 0;
            margin-top: 2px;

            @media screen and (max-width: 700px) {
              margin-top: 3px;
            }

            &__item {
              font-size: 13px;
              line-height: 137%;
              max-width: 300px;
              //margin-bottom: 2px;

              @media screen and (max-width: 768px) {
                margin-right: 10px;
              }

              @media screen and (max-width: 700px) {
                max-width: 100%;
              }

              &__icon {
                vertical-align: text-bottom;
                display: inline-block;
                margin-left: 6px;

                ::v-deep & svg:focus {
                  outline: none !important;
                  box-shadow: none !important;
                }
              }
            }
          }
        }

        &__experience {
          margin-top: 3px;
          font-size: 13px;
          line-height: 120%;
          color: #8e9cbb;

          @media screen and (max-width: 700px) {
            // display: none;
            margin: -10px 0 13px -65px;
          }

          &__mobile {
            margin-top: 1px;
            margin-bottom: 19px;
            font-size: 13px;
            line-height: 120%;
            color: #8e9cbb;
            display: none;

            @media screen and (max-width: 700px) {
              display: block;
            }
          }
        }
      }
    }

    &__buttons {
      display: flex;
      margin-top: 15px;

      @media screen and (max-width: 700px) {
        margin-top: 0;
        margin-bottom: 12px;
      }

      &__top {
        margin-right: 11px;

        &__comment__mobile {
          @media screen and (min-width: 769px) {
            display: none;
          }
        }

        &__comment__bubble {
          margin-right: 29px;

          @media screen and (max-width: 768px) {
            display: none;
          }
        }
      }

      &__to__employees__list {
        @media screen and (max-width: 768px) {
          padding: 0;
          border-radius: 50%;
          -webkit-box-pack: center;
          -ms-flex-pack: center;
          justify-content: center;
          text-align: center;
          width: 30px;
        }

        ::v-deep & .c-button-icon {
          @media screen and (max-width: 768px) {
            margin-right: 0 !important;
            margin-left: 0 !important;
          }
        }

        ::v-deep & .c-button-label {
          @media screen and (max-width: 768px) {
            display: none;
          }
        }
      }
    }
  }
}

::v-deep .viewer-backdrop {
  background-color: rgba(0, 0, 0, 0.7) !important;
}

::v-deep .viewer-prev,
::v-deep .viewer-play,
::v-deep .viewer-next,
::v-deep .viewer-one-to-one {
  display: none !important;
}

@media (max-width: 1023px) {
  .only-desktop {
    display: none;
  }

  /deep/ {
    .c-button_icon_comment {
      width: 30px;
      height: 30px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      .c-button-label {
        display: none;
      }
      .c-button-icon {
        margin: 0;
      }
    }
  }
}

</style>
